export class NumberingMapping {
    public static intTostring(int: number): string {
        return int.toString();
    }

    public static intToRoman(num: number): string {
        if (isNaN(num)) {
            return '';
        }

        const digits = String(+num).split('');
        const key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM',
            '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC',
            '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
        let roman = '';
        let i = 3;

        while (i--) {
            roman = (key[Number(digits?.pop()) + (i * 10)] || '') + roman; 
        }

        return Array(+digits.join('') + 1).join('M') + roman;
    }

    public static intToUpperCaseCharacter(value: number): string {
        if (isNaN(value)) {
            return '';
        }

        const base = 26;
        const values: number[] = [];
        if (value === 0) {
            values.push(0);
        }
        while (value > 0) {
            values.push(value % base);
            value = Math.floor(value / base);
        }

        let str = '';
        let count = 0;
        values.forEach(val => {
            if (count > 0) {
                val--;
            }
            str += String.fromCharCode(val + 65);
            count++;
        });

        return str.split('').reverse().join('');
    }
}
